import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin } from 'rxjs';
import { LookupValuesService } from '../../common/lookup-values.service';
import { UserService } from '../../services/UserService';

@Injectable({
    providedIn: 'root'
})
export class UserPasswordResetResolverService implements Resolve<any>{

    constructor(private lookupvaluesservice: LookupValuesService, private userService: UserService) { }

    resolve(route: ActivatedRouteSnapshot) {
        let parms = {
            userid: route.paramMap.get('userid'),
            token: route.paramMap.get('token'),           
        };
        return parms;
    }
}
